/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropbox_ErrorInputs */

const en_dropbox_error = /** @type {(inputs: Dropbox_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not open Dropbox. Try again or reconnect your account in Integrations.`)
};

const es_dropbox_error = /** @type {(inputs: Dropbox_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo abrir Dropbox. Inténtalo de nuevo o vuelve a conectar tu cuenta en Integraciones.`)
};

/**
* | output |
* | --- |
* | "Could not open Dropbox. Try again or reconnect your account in Integrations." |
*
* @param {Dropbox_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dropbox_error = /** @type {((inputs?: Dropbox_ErrorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropbox_ErrorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dropbox_error(inputs)
	return en_dropbox_error(inputs)
});